import * as yup from 'yup';

export const getTagFormDependencies = (tagGroups, translate, defaultTags) => {
    const mandatoryTagGroups = getMandatoryTagGroups(tagGroups);
    const optionalTags = getOptionalTags(tagGroups);
    const fields = getFields(mandatoryTagGroups, translate);
    const defaultValues = getDefaultValues(optionalTags, mandatoryTagGroups, defaultTags);
    return {
        mandatoryTagGroups: mandatoryTagGroups,
        optionalTags: optionalTags,
        fields: fields,
        defaultValues: defaultValues,
    }
}

export const getMandatoryTagGroups = (tagGroups) => {
    let mandatoryTagGroups = tagGroups
        ?.filter(tagGroup => tagGroup.mandatory_on_upload)
    ?? [];
    for (let mandatoryTagGroup of mandatoryTagGroups) {
        mandatoryTagGroup.field_key = 'mandatory_tag_group_' + mandatoryTagGroup.id.replace('-', '');
    }
    return mandatoryTagGroups;
};

export const getOptionalTags = (tagGroups) => {
    const optionalTags = Array.prototype.concat.apply([], tagGroups?.map(function (tagGroup) {
        if (tagGroup.mandatory_on_upload) {
            return [];
        }
        const groupTags = tagGroup.tags?.map(function (tag) {
            return {
                id: tag.id,
                name: tag.name,
                group: tagGroup.name
            };
        });
        return groupTags;
    }) ?? []);
    return optionalTags;
}

export const getFields = (mandatoryTagGroups, translate) => {
    let fields = {};
    for (let tagGroup of mandatoryTagGroups) {
        fields[tagGroup.field_key] = yup
            .array()
            .min(1, translate(`cmss.resources.file-explorer.tags.messages.mandatory-tag-group-required`))
            .required(translate(`cmss.resources.file-explorer.tags.messages.mandatory-tag-group-required`));
    }
    fields.optional_tags = yup
        .array()
        .nullable();
    return fields;
}

export const getDefaultValues = (optionalTags, mandatoryTagGroups, defaultTags) => {
    const defaultTagIds = new Set(defaultTags?.map(tag => tag.id) ?? []);
    let defaultValues = {};
    for (let tagGroup of mandatoryTagGroups) {
        defaultValues[tagGroup.field_key] = tagGroup.tags.filter(tag => defaultTagIds.has(tag.id));
    }
    defaultValues.optional_tags = optionalTags.filter(tag => defaultTagIds.has(tag.id));
    return defaultValues;
}